import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext.jsx";

// Route guard: renders the protected children only when authenticated,
// otherwise redirects to /login.
export default function RequireAuth() {
  const { authed } = useAuth();
  if (!authed) return <Navigate to="/login" replace />;
  return <Outlet />;
}
